import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import PropTypes from "prop-types";

import QuestionsTab from "./Tabs/QuestionsTab";
import KYCTab from "./Tabs/KYCTab";
import DocumentsTab from "./Tabs/DocumentsTab";
import ProfileTab from "./Tabs/ProfileTab";
import InvestmentProfileTab from "./Tabs/InvestmentProfileTab";
import HoldersTab from "./Tabs/HoldersTab";
import SignatureSetsTab from "./Tabs/SignatureSetsTab";
import PersonalReferencesTab from "./Tabs/PersonalReferencesTab";
import BankAccountsTab from "./Tabs/BankAccountsTab";
import RelatedAccountsTab from "./Tabs/RelatedAccountsTab";
import CommissionTab from "./Tabs/CommissionsTabs";
import GroupsTab from "./Tabs/GroupsTab";
import { getAccountType } from "./types";
import { UserType, AccountMode, showToast } from "../../../utils/Helper";
import BeneficiariesTab from "./Tabs/BeneficiariesTab";
import Finalize from "./Tabs/FinalizeAccountTab";
import InstructionsTab from "./Tabs/InstructionsTab";

const AccountTabs = ({
  account,
  userType,
  questions,
  KYC,
  documents,
  signatureSets,
  archivesTypes,
  riskTypes,
  holders,
  disabledFields,
  investment,
  references,
  bankAccounts,
  relatedAccounts,
  currencies,
  companyLinks,
  reps,
  groups,
  banks,
  setAccountData,
  services,
  mode,
  setRedirectAccounts,
  setRedirectAccount,
  Link,
  refresh,
  riskByPersonIsEnabled,
  riskByPersonIsZero,
  instructions,
  useRevenueProcess,
  newTLFormulaEnabled = false,
  newOnboardingVersion = false,
  userRoles,
}) => {
  const [tab, setTab] = useState(getAccountType.Profile);
  const [tabErrors, setTabErrors] = useState(false);
  const saveAccountData = (acc, edit, needAuth) => {
    setAccountData({ ...account, ...acc }, edit, needAuth);
  };
  const changeTab = (newTab) => {
    if (tabErrors) {
      showToast("Please Check Fields", true);
      return null;
    }
    if (mode === AccountMode.New && account.AccountOnboardingId !== "") {
      setTab(newTab);
    }
    if (mode !== AccountMode.New && account.AccountId > 0) {
      setTab(newTab);
    }
  };
  const [enableField, setEnableField] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(userType == UserType.FundManager);

  return (
    <Card>
      <CardHeader>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: tab === getAccountType.Profile })}
              onClick={() => changeTab(getAccountType.Profile)}
            >
              <i className="fa fa-user" /> Profile
            </NavLink>
          </NavItem>
          {userType === UserType.Advisor && mode !== AccountMode.New && (
            <NavItem>
              <NavLink
                className={classnames({
                  active: tab === getAccountType.Commissions,
                })}
                onClick={() => changeTab(getAccountType.Commissions)}
              >
                <i className="fa fa-money" /> Commission
              </NavLink>
            </NavItem>
          )}
          {!newOnboardingVersion && (
            <NavItem>
              <NavLink
                className={classnames({ active: tab === getAccountType.Questions })}
                onClick={() => changeTab(getAccountType.Questions)}
              >
                <i className="fa fa-th-list" /> Investment Q&A
              </NavLink>
            </NavItem>
          )}
          {/* 
          Se comenta porque no tiene datos asociados, vemos si despues se usa para algo. 
          <NavItem>
            <NavLink
              className={classnames({
                active: tab === getAccountType.InvestmentProfile
              })}
              onClick={() => changeTab(getAccountType.InvestmentProfile)}
            >
              <i className="fa fa-pie-chart" /> Investment Profile
            </NavLink>
          </NavItem> */}
          {!newOnboardingVersion && (
            <NavItem>
              <NavLink
                className={classnames({ active: tab === getAccountType.KYC })}
                onClick={() => changeTab(getAccountType.KYC)}
              >
                <i className="fa fa-shopping-cart" /> KYC
              </NavLink>
            </NavItem>
          )}
          <NavItem>
            <NavLink
              className={classnames({ active: tab === getAccountType.Documents })}
              onClick={() => changeTab(getAccountType.Documents)}
            >
              <i className="fa fa-folder" /> Documents
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: tab === getAccountType.Holders })}
              onClick={() => changeTab(getAccountType.Holders)}
            >
              <i className="fa fa-users" /> Holders
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: tab === getAccountType.Beneficiaries,
              })}
              onClick={() => changeTab(getAccountType.Beneficiaries)}
            >
              <i className="fa fa-users" /> Beneficiaries
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: tab === getAccountType.SignatureSets,
              })}
              onClick={() => changeTab(getAccountType.SignatureSets)}
            >
              <i className="fa fa-pencil" /> Signature Sets
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: tab === getAccountType.References,
              })}
              onClick={() => changeTab(getAccountType.References)}
            >
              <i className="fa fa-retweet" /> Personal References
            </NavLink>
          </NavItem>
          {!newOnboardingVersion && (
            <NavItem>
              <NavLink
                className={classnames({
                  active: tab === getAccountType.BankAccounts,
                })}
                onClick={() => changeTab(getAccountType.BankAccounts)}
              >
                <i className="fa fa-university" /> Bank Accounts
              </NavLink>
            </NavItem>
          )}
          {mode !== AccountMode.New && !newOnboardingVersion && (
            <NavItem>
              <NavLink
                className={classnames({
                  active: tab === getAccountType.RelatedAccounts,
                })}
                onClick={() => changeTab(getAccountType.RelatedAccounts)}
              >
                <i className="fa fa-address-book" /> Related Accounts
              </NavLink>
            </NavItem>
          )}
          {(mode !== AccountMode.New || newOnboardingVersion) && (
            <NavItem>
              <NavLink
                className={classnames({
                  active: tab === getAccountType.Groups,
                })}
                onClick={() => changeTab(getAccountType.Groups)}
              >
                <i className="fa fa-object-group mr-1" /> Groups
              </NavLink>
            </NavItem>
          )}
          {(mode !== AccountMode.New || newOnboardingVersion) && useRevenueProcess == true && (
            <NavItem>
              <NavLink
                className={classnames({
                  active: tab === getAccountType.Instructions,
                })}
                onClick={() => changeTab(getAccountType.Instructions)}
              >
                <i className="fa fa-list-alt" /> Instructions
              </NavLink>
            </NavItem>
          )}
          {((mode === AccountMode.New && userType === "Compliance") || newOnboardingVersion) && (
            <NavItem>
              <NavLink
                className={classnames({
                  active: tab === getAccountType.Finalize,
                })}
                onClick={() => changeTab(getAccountType.Finalize)}
              >
                <i class="fa fa-check-square-o" aria-hidden="true"></i> Finalize
              </NavLink>
            </NavItem>
          )}
        </Nav>
      </CardHeader>
      <CardBody>
        {tab === getAccountType.Profile && (
          <ProfileTab
            account={account}
            userType={userType}
            isReadOnly={isReadOnly}
            currencies={currencies}
            setAccountData={saveAccountData}
            riskTypes={riskTypes}
            companyLinks={companyLinks}
            reps={reps}
            services={services}
            mode={mode}
            tab={tab}
            setTabErrors={setTabErrors}
            enableField={enableField}
            setRedirectAccount={setRedirectAccount}
            newOnboardingVersion={newOnboardingVersion}
            userRoles={userRoles}
            newTLFormulaEnabled={newTLFormulaEnabled}
          />
        )}
        {tab === getAccountType.Questions && (
          <QuestionsTab
            isReadOnly={isReadOnly}
            account={account}
            accountId={account.AccountId}
            questions={questions}
            setAccountData={saveAccountData}
            services={services}
            mode={mode}
            riskByPersonIsEnabled={riskByPersonIsEnabled}
          />
        )}
        {tab === getAccountType.KYC && (
          <KYCTab
            isReadOnly={isReadOnly}
            account={account}
            accountId={account.AccountId}
            KYC={KYC}
            setAccountData={saveAccountData}
            services={services}
            mode={mode}
          />
        )}
        {tab === getAccountType.Documents && (
          <DocumentsTab
            isReadOnly={isReadOnly}
            account={account}
            accountId={account.AccountId}
            documents={documents}
            archivesTypes={archivesTypes}
            setAccountData={saveAccountData}
            services={services}
            refresh={refresh}
            mode={mode}
            newOnboardingVersion={newOnboardingVersion}
          />
        )}
        {tab === getAccountType.InvestmentProfile && (
          <InvestmentProfileTab
            account={account}
            accountId={account.AccountId}
            investment={investment}
            setAccountData={saveAccountData}
            services={services}
            mode={mode}
          />
        )}
        {tab === getAccountType.Holders && (
          <HoldersTab
            holders={account.AccountInfoHolder.filter(
              (holder) =>
                holder.AccountHolderRelationship !== "Beneficiary" ||
                holder.AccountHolderRelationshipJuridical !== "Beneficiary",
            )}
            accountId={account.AccountId}
            account={account}
            setAccountData={saveAccountData}
            services={services}
            disabledFields={disabledFields}
            userType={userType}
            isReadOnly={isReadOnly}
            disabledviaLink={true}
            mode={mode}
            Link={Link}
            newOnboardingVersion={newOnboardingVersion}
          />
        )}
        {tab === getAccountType.Beneficiaries && (
          <BeneficiariesTab
            holders={account.AccountInfoHolder.filter(
              (holder) =>
                holder.AccountHolderRelationship === "Beneficiary" ||
                holder.AccountHolderRelationshipJuridical === "Beneficiary" ||
                holder.AccountHolderIsBeneficiary === true,
            )}
            accountId={account.AccountId}
            account={account}
            setAccountData={saveAccountData}
            services={services}
            userType={userType}
            isReadOnly={isReadOnly}
            mode={mode}
            Link={Link}
            newOnboardingVersion={newOnboardingVersion}
          />
        )}
        {tab === getAccountType.SignatureSets && (
          <SignatureSetsTab
            isReadOnly={isReadOnly}
            account={account}
            accountId={account.AccountId}
            signatureSets={signatureSets}
            holders={account.AccountInfoHolder}
            setAccountData={saveAccountData}
            services={services}
            mode={mode}
            newOnboardingVersion={newOnboardingVersion}
          />
        )}
        {tab === getAccountType.References && (
          <PersonalReferencesTab
            isReadOnly={isReadOnly}
            account={account}
            accountId={account.AccountId}
            references={references}
            setAccountData={saveAccountData}
            services={services}
            mode={mode}
            newOnboardingVersion={newOnboardingVersion}
          />
        )}
        {tab === getAccountType.BankAccounts && (
          <BankAccountsTab
            account={account}
            accountId={account.AccountId}
            bankAccounts={account.BankAccounts}
            isReadOnly={isReadOnly}
            currencies={currencies}
            setAccountData={saveAccountData}
            services={services}
            banks={banks ? banks.filter((b) => parseInt(b.Code, 10) > 0) : undefined}
            mode={mode}
            setRedirectAccounts={setRedirectAccounts}
            riskByPersonIsZero={riskByPersonIsZero}
            isMainHolderJuridical={!account.AccountIsPhysical}
          />
        )}
        {tab === getAccountType.Commissions && userType === UserType.Advisor && (
          <CommissionTab
            account={account}
            accountId={account.AccountId}
            setAccountData={saveAccountData}
            services={services}
            mode={mode}
          />
        )}
        {tab === getAccountType.RelatedAccounts && (
          <RelatedAccountsTab
            isReadOnly={isReadOnly}
            accountId={account.AccountId}
            relatedAccounts={relatedAccounts}
            setAccountData={saveAccountData}
            services={services}
            banks={banks}
            mode={mode}
          />
        )}
        {tab === getAccountType.Finalize && (
          <Finalize
            account={account}
            accountId={account.AccountId}
            setAccountData={saveAccountData}
            services={services}
            mode={mode}
            setRedirectAccount={setRedirectAccount}
            userType={userType}
            newOnboardingVersion={newOnboardingVersion}
          />
        )}
        {tab === getAccountType.Groups && (
          <GroupsTab
            isReadOnly={isReadOnly}
            account={account}
            accountId={account.AccountId}
            setAccountData={saveAccountData}
            services={services}
            groups={groups}
            mode={mode}
            newOnboardingVersion={newOnboardingVersion}
          />
        )}
        {tab === getAccountType.Instructions && (
          <InstructionsTab
            instructions={instructions}
            accountId={account.AccountId}
            bankAccounts={account.BankAccounts}
            setAccountData={saveAccountData}
            services={services}
            currencies={currencies}
            mode={mode}
            userType={userType}
            newOnboardingVersion={newOnboardingVersion}
          />
        )}
      </CardBody>
    </Card>
  );
};

AccountTabs.propTypes = {
  account: PropTypes.object.isRequired,
  userType: PropTypes.string.isRequired,
  setAccountData: PropTypes.func.isRequired,
  questions: PropTypes.array,
  KYC: PropTypes.object,
  documents: PropTypes.array,
  signatureSets: PropTypes.array,
  archivesTypes: PropTypes.object,
  riskTypes: PropTypes.array,
  holders: PropTypes.array.isRequired,
  investment: PropTypes.array,
  references: PropTypes.array,
  currencies: PropTypes.array,
  bankAccounts: PropTypes.array,
  relatedAccounts: PropTypes.array,
  companyLinks: PropTypes.array,
  banks: PropTypes.array,
  reps: PropTypes.array,
  services: PropTypes.object.isRequired,
  groups: PropTypes.array,
  userRoles: PropTypes.array,
};

AccountTabs.defaultProps = {
  questions: undefined,
  KYC: undefined,
  documents: undefined,
  signatureSets: undefined,
  archivesTypes: undefined,
  riskTypes: undefined,
  investment: undefined,
  references: undefined,
  currencies: undefined,
  bankAccounts: undefined,
  relatedAccounts: undefined,
  companyLinks: undefined,
  reps: undefined,
  banks: undefined,
  groups: undefined,
  userRoles: undefined,
};

export default AccountTabs;
